import { render, staticRenderFns } from "./ReplyDeliveryTime.vue?vue&type=template&id=b870cf08&scoped=true&"
import script from "./ReplyDeliveryTime.vue?vue&type=script&lang=js&"
export * from "./ReplyDeliveryTime.vue?vue&type=script&lang=js&"
import style0 from "./ReplyDeliveryTime.vue?vue&type=style&index=0&id=b870cf08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b870cf08",
  null
  
)

export default component.exports